import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'

const FooterBar = styled.footer`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.9);
  color: #f0f0f0;
  text-align: center;
  padding: 0.65rem 1rem;
  font-size: 0.85rem;
  line-height: 1;
  z-index: 10;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;

  a {
    color: #f0f0f0;
    text-decoration: none;
    font-style: normal;
    margin: 0 0.6rem;
  }

  a:hover,
  a:focus {
    text-decoration: underline;
  }

  span {
    color: #888;
  }
`

const Footer = () => (
  <FooterBar>
    <Link to="/privacy">Privacy Policy</Link>
    <span aria-hidden="true">&bull;</span>
    <Link to="/terms">Terms and Conditions</Link>
  </FooterBar>
)

export default Footer
